export enum CONTENT_NAMES {
    Initial = "initial",
    Language = "language",
    TimeZone = "timeZone",
    TutorialMode = "tutorialMode"
}
